const trigger = document.querySelector('#query-btn');
const popup = document.querySelector('[data-popup-id="meaning-popup"]');
const closeBtn = popup.querySelector('.popup-close');

// 打开弹窗 + 添加翻转效果
trigger.addEventListener('click', () => {
  popup.classList.remove('hidden');
  setTimeout(() => {
    popup.classList.add('show');
  }, 10); // 等待一帧再加 .show 以触发动画
});

// 关闭弹窗 + 移除翻转效果
closeBtn.addEventListener('click', () => {
  popup.classList.remove('show');
  setTimeout(() => {
    popup.classList.add('hidden');
  }, 600); // 等待动画结束后隐藏
});

// 卦象解释数据库
const symbolExplanations = {
    // 第一层解释
    "level1": {
        "1": '<strong>Ra</strong>: Sun god of truth and creation. Symbolizes ultimate laws, bigger-picture trends, and an unchangeable fate.',
        "2": "<strong>Osiris</strong>: Ruler of the underworld. Signifies endings, transformation, and necessary sacrifice for rebirth.",
        "3": "<strong>Isis</strong>: Goddess of magic and life. Suggests protection, secret insight, or help from allies (often feminine energy).",
        "4": "<strong>Horus</strong>: God of kingship and the skies. Reveals truth, justice, legal victory, and the strength to fight for what’s right."
    },
    // 第二层解释
    "level2": {
        "1": "<strong>Flooding Nile</strong>: Abundant yet chaotic. Brings sudden change, opportunities, and resources—but not without risk.",
        "2": "<strong>Harvest Wheat</strong>: Sign of prosperity and completion. It's time to harvest, distribute, and give thanks.",
        "3": "<strong>War Chariot</strong>: High-speed movement. Indicates fierce rivalry, ambitious expansion, or urgent teamwork.",
        "4": "<strong>Hourglass</strong>: Time is running out. Represents deadlines, efficiency, and unavoidable cause-and-effect."
    },
    // 第三层解释
    "level3": {
        "1": "<strong>Advance</strong>: March forward with courage. Symbolizes taking initiative, bold moves, and strict execution.",
        "2": "<strong>Sacrifice</strong>:Give something to gain something. Suggests letting go of distractions to protect what truly matters.",
        "3": "<strong>Script</strong>: Pen is power. Indicates writing, strategizing, recording facts, or influencing through knowledge.",
        "4": "<strong>Endure</strong>: Stay still and conserve energy. Suggests patience, internal strength, or holding back until the moment is right."
    }
};

// 寓意数据库 - 保持不变
        const meaningsDatabase = {
            // 格式: "1-1-1": "对应的寓意"
            // 第一层-第二层-第三层
            "1-1-1": "Act quickly in times of upheaval to build a new order.",
            "1-1-2": "Let go of old systems and ride the wave of change to create fresh opportunities.",
            "1-1-3": "Guide chaotic energy with a clear plan to avoid reckless decisions.",
            "1-1-4": "Observe briefly, but step in decisively at critical moments.",
            "1-2-1": "During stable times, proactively expand to avoid slipping into comfort-driven stagnation.",
            "1-2-2": "Give up some short-term gains to achieve bigger breakthroughs—beware of playing it too safe.",
            "1-2-3": "Strengthen your current resources and plan long-term to sustain prosperity.",
            "1-2-4": "Enjoy your success, but quietly prepare for potential risks.",
            "1-3-1": "Face competition head-on and win leadership with creative strategies.",
            "1-3-2": "Let go of minor gains to focus your strength on striking your opponent's weak spot.",
            "1-3-3": "Resolve conflict through negotiation or new rules—not brute force.",
            "1-3-4": "Wait for your opponent to show a flaw, then strike with precision.",
            "1-4-1": "Act fast under pressure, but keep your goals clear.",
            "1-4-2": "Drop the habit of procrastination—tackle core tasks first.",
            "1-4-3": "Plan your timeline precisely to stay focused and avoid getting distracted by small stuff.",
            "1-4-4": "Accept that some waiting is necessary, but set a deadline to avoid passivity.",
            "2-1-1": "Rebuild order from chaos by uprooting the rot at its core.",
            "2-1-2": "Consciously end old cycles to make room for new growth.",
            "2-1-3": "Document your failures and build unshakable new principles.",
            "2-1-4": "Endure the trials of chaos while waiting for inner transformation.",
            "2-2-1": "Break through false prosperity to expose and eliminate hidden threats.",
            "2-2-2": "Let go of material excess and seek spiritual abundance.",
            "2-2-3": "Reevaluate what success really means—don't be fooled by appearances.",
            "2-2-4": "Watch out for decay beneath stability and prepare for change.",
            "2-3-1": "Step into conflict with fairness and bring unjust battles to an end.",
            "2-3-2": "Let go of personal pride for the long-term peace of the group.",
            "2-3-3": "Build systems for fair judgment—replace chaos with structure.",
            "2-3-4": "Step back from conflict and act once both sides have worn each other out.",
            "2-4-1": "Finish what matters before time runs out—leave no regrets.",
            "2-4-2": "Release attachment and accept irreversible endings.",
            "2-4-3": "Close the chapter on the past and begin writing a new one.",
            "2-4-4": "Let cause and effect unfold naturally—don't force your hand.",
            "3-1-1": "Channel the chaos into a force that fuels growth and life.",
            "3-1-2": "Sacrifice personal gains to shield the group from disaster.",
            "3-1-3": "Use communication and teamwork to calm fear and rebuild trust.",
            "3-1-4": "Trust the power of natural cycles—don't over-control.",
            "3-2-1": "Share surplus resources with those in need to strengthen the community.",
            "3-2-2": "Give generously to build deeper, lasting relationships.",
            "3-2-3": "Create fair systems of distribution to prevent greed from taking root.",
            "3-2-4": "Protect the current balance, but stay alert to hidden injustice.",
            "3-3-1": "Step in as a peacemaker and help both sides find common ground.",
            "3-3-2": "Offer compromise for peace, but never sacrifice your core values.",
            "3-3-3": "Create mutually respected agreements to end the cycle of resentment.",
            "3-3-4": "Stay neutral and wait for tempers to cool before restarting the conversation.",
            "3-4-1": "Mend broken ties before time runs out—don't let distance become permanent.",
            "3-4-2": "Release old grudges and focus on the healing opportunities of now.",
            "3-4-3": "Speak your heart honestly to clear up misunderstandings caused by time and silence.",
            "3-4-4": "Give others space to grow and allow healing to unfold naturally.",
            "4-1-1": "Seize the moment in chaos and lead the way into a new order.",
            "4-1-2": "Abandon side battles to focus everything on your main challenge.",
            "4-1-3": "Craft your strategy quickly and command the big picture with clarity.",
            "4-1-4": "Lay low and watch your opponent—then strike when the time is right.",
            "4-2-1": "Turn your current strengths into tools for expansion—don't just cling to what you've built.",
            "4-2-2": "Step out of your comfort zone and aim for a higher level of success.",
            "4-2-3": "Document what works so your victories can be repeated.",
            "4-2-4": "Strengthen your foundation while quietly planning your next move.",
            "4-3-1": "End the competition with overwhelming advantage and claim your place at the top.",
            "4-3-2": "Give up short-term wins for a major strategic breakthrough.",
            "4-3-3": "Use mind games or public perception to break your opponent's spirit.",
            "4-3-4": "Hide your true power, then strike when your opponent lets their guard down.",
            "4-4-1": "Hit your goals within the deadline to show unstoppable execution.",
            "4-4-2": "Cut the fluff—go straight to the heart of the problem.",
            "4-4-3": "Break your plan into clear phases and hit each milestone with precision.",
            "4-4-4": "Wait for the perfect timing—then act with sharp, focused precision.",
        };

        // 当前选择的卦象
        let currentSelection = {
            level1: null,
            level2: null,
            level3: null
        };

        // 初始化页面
        document.addEventListener('DOMContentLoaded', function () {
            // 为所有卦象选项添加点击事件
            document.querySelectorAll('.symbol-option').forEach(option => {
                option.addEventListener('click', function () {
                    const level = this.parentElement.id.replace('level', '');
                    const symbol = this.dataset.symbol;
                    selectSymbol(level, symbol);
                });
            });

            // 查询按钮点击事件
            document.getElementById('query-btn').addEventListener('click', function () {
                const meaning = getMeaning(
                    currentSelection.level1,
                    currentSelection.level2,
                    currentSelection.level3
                );

                document.getElementById('result-text').textContent = meaning;

                // 更新URL，方便直接分享
                updateURL();
            });

            // 分享功能代码（保持不变）
            document.getElementById('copy-link-btn').addEventListener('click', function () {
                const currentUrl = window.location.href;
                navigator.clipboard.writeText(currentUrl).then(() => {
                    const successMsg = document.getElementById('share-success');
                    successMsg.style.opacity = '1';
                    setTimeout(() => {
                        successMsg.style.opacity = '0';
                    }, 2000);
                });
            });

            document.getElementById('share-wechat').addEventListener('click', function () {
                alert('请使用微信内置的分享功能或截图分享');
            });

            document.getElementById('share-weibo').addEventListener('click', function () {
                const currentUrl = encodeURIComponent(window.location.href);
                const title = encodeURIComponent(`我的算命吊坠寓意：${document.getElementById('result-text').textContent.substring(0, 30)}...`);
                window.open(`https://service.weibo.com/share/share.php?url=${currentUrl}&title=${title}`, '_blank');
            });

            // 检查URL参数
            checkURLParameters();
        });

        // 选择卦象的函数
function selectSymbol(level, symbol) {
    // 更新当前选择
    currentSelection[`level${level}`] = symbol;
    
    // 更新UI显示
    const options = document.querySelectorAll(`#level${level} .symbol-option`);
    options.forEach(opt => {
        opt.classList.remove('selected');
        if (opt.dataset.symbol === symbol) {
            opt.classList.add('selected');
        }
    });
    
    // 显示解释 (使用innerHTML而不是textContent)
    const explanationContainer = document.getElementById(`level${level}-explanation`);
    explanationContainer.innerHTML = symbolExplanations[`level${level}`][symbol];
    explanationContainer.style.display = 'block';
    
    // 检查是否所有层都已选择
    checkAllSelected();
}

        // 检查是否所有层都已选择
        function checkAllSelected() {
            const allSelected = currentSelection.level1 &&
                currentSelection.level2 &&
                currentSelection.level3;

            document.getElementById('query-btn').disabled = !allSelected;
        }

        // 获取寓意
        function getMeaning(level1, level2, level3) {
            const key = `${level1}-${level2}-${level3}`;
            return meaningsDatabase[key] || "未找到对应的寓意，请检查数据。";
        }

        // 更新URL函数
        function updateURL() {
            const newUrl = `${window.location.origin}${window.location.pathname}?l1=${currentSelection.level1}&l2=${currentSelection.level2}&l3=${currentSelection.level3}`;
            window.history.pushState({}, '', newUrl);
        }


        // 检查URL参数，如果有则自动填充选择
function checkURLParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    const l1 = urlParams.get('l1');
    const l2 = urlParams.get('l2');
    const l3 = urlParams.get('l3');
    
    if (l1 && l2 && l3) {
        // 模拟点击选择对应的卦象
        const level1Option = document.querySelector(`#level1 .symbol-option[data-symbol="${l1}"]`);
        const level2Option = document.querySelector(`#level2 .symbol-option[data-symbol="${l2}"]`);
        const level3Option = document.querySelector(`#level3 .symbol-option[data-symbol="${l3}"]`);
        
        if (level1Option && level2Option && level3Option) {
            level1Option.click();
            level2Option.click();
            level3Option.click();
            
            // 自动触发查询
            document.getElementById('query-btn').click();
        }
    }
}